/*global TTTask */
/*eslint no-undef: "error"*/
import React, { Component } from 'react';
import { v2Api }            from 'moovila-common';
import { connect }          from 'react-redux';
import validator            from 'validator';

import {
  showMessageBox,
  getTaskInfo,
  calculateTaskRepeat,
  clearRepeats,
} from '../../actions';

import RepeatTester from '../../components/Utilities/RepeatTester';

let task;

class RepeatTesterContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      onlyDifferences: false,
    };

    this.validate       = this.validate.bind(this);
    this.getRepeats     = this.getRepeats.bind(this);
    this.processRepeats = this.processRepeats.bind(this);
  }

  componentWillMount() {
    task = null;
  }

  validate(guid) {
    // sample to test repeats     3d26a6e9-e1d4-4568-8d08-2be7ebe323b5
    // sample to test no repeats  bc29d277-c3b0-4db7-a26f-60535d50dfa8
    if (!guid.length) {
      this.props.showMessageBox({
        title: 'Invalid Entry',
        message: 'Sorry, could you please enter a Task GUID?'
      });
      return false;
    }
    if (!validator.isUUID(guid)) {
      this.props.showMessageBox({
        title: 'Invalid Entry',
        message: 'Hm, that doesn\'t seem to be a valid GUID'
      });
      return false;
    }
    return true;
  }

  getRepeats(guid, onlyDifferences = false) {
    this.props.clearRepeats();
    if (this.validate(guid)) {
      this.setState({loading: true});
      this.props.getTaskInfo(guid);
      v2Api.fetch('Task/GetTaskInfo', { taskGUID: guid })
        .then(({data}) => {
          task = new TTTask(data);
          if (task.isRepeat) {
            this.props.calculateTaskRepeat(guid);
            if (onlyDifferences) {
              this.setState({onlyDifferences: true});
            } else {
              this.setState({onlyDifferences: false});
            }
            this.processRepeats();
          } else {
            this.props.showMessageBox({
              title: 'No Repeat Set',
              message: 'The task GUID provided is not a repeating task'
            });
          }
          this.setState({loading: false})
        })
        .catch(() => {
          this.setState({loading: false});
          this.props.showMessageBox({
            title: 'Error',
            message: 'Sorry, there was an unknown error with your request'
          });
        });
    }
  }

  processRepeats() {
    const emptyReturn = {
      client: [],
      server: [],
    };

    if (!Object.keys(this.props.repeatTester.task).length || !this.props.repeatTester.server.length || !task) {
      return emptyReturn;
    }

    let client = task.Repeat.GenerateRepeatDateArray(true, task.taskDueDate);
    let server = this.props.repeatTester.server;
    let filteredClient;
    let filteredServer;

    if (this.state.onlyDifferences) {
      filteredClient = client.filter(clientDay => server.every(serverDay => serverDay.toUTCString() !== clientDay.toUTCString()));
      filteredServer = server.filter(serverDay => client.every(clientDay => clientDay.toUTCString() !== serverDay.toUTCString()));
      client = filteredClient;
      server = filteredServer;
    }
    
    return {
      client,
      server,
    };
  }
  
  render() {
    return (
      <RepeatTester
        repeats={this.processRepeats()}
        getRepeats={this.getRepeats}
      />
    );
  }
}

export default connect(s => s, {
  showMessageBox,
  getTaskInfo,
  calculateTaskRepeat,
  clearRepeats,
})(RepeatTesterContainer);



// WEBPACK FOOTER //
// ./src/containers/Utilities/RepeatTester.js